import { render, staticRenderFns } from "./PlainInput.vue?vue&type=template&id=666e9c54&scoped=true&"
import script from "./PlainInput.vue?vue&type=script&lang=js&"
export * from "./PlainInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e9c54",
  null
  
)

export default component.exports